import { IconBackground } from './IconBackground';

export type { TypeIconBackgroundProps } from './types';
export default IconBackground;
